import axios from "axios";
import type { Designations } from "../../domain/entities/Designations";
import { ApiConfig } from "../config/apiConfig";

export class DesignationsApi {
  async getDesignations(): Promise<Designations[]> {
    const response = await axios.get(ApiConfig.DESIGNATIONS);

    return response.data.data.designations
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      .map((designations: any) => ({
        id: designations.id,
        name: designations.name,
        description: designations.description,
        is_active: designations.is_active,
        created_at: designations.created_at,
        updated_at: designations.updated_at,
      }))
      .sort();
  }
}
